import { TenantActivity } from "../../services/packageService";

interface TenantActivityTableProps {
  data: TenantActivity[];
  isLoading?: boolean;
}

export default function TenantActivityTable({ data, isLoading }: TenantActivityTableProps) {
  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getStatusBadge = (status: string) => {
    const statusColors: Record<string, string> = {
      DELIVERED: "bg-green-100 text-green-700",
      PENDING: "bg-yellow-100 text-yellow-700",
      ASSIGNED: "bg-blue-100 text-blue-700",
      LOGGED: "bg-purple-100 text-purple-700",
    };

    return (
      <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${statusColors[status] || "bg-gray-100 text-gray-700"}`}>
        {status}
      </span>
    );
  };

  if (isLoading) {
    return (
      <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
        <div className="p-5 sm:p-6">
          <h3 className="text-lg font-semibold text-gray-800 dark:text-white/90">
            Tenant's Activity
          </h3>
        </div>
        <div className="flex items-center justify-center py-12">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand-500 border-t-transparent"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
      <div className="p-5 sm:p-6">
        <h3 className="text-lg font-semibold text-gray-800 dark:text-white/90">
          Tenant's Activity
        </h3>
      </div>

      <div className="max-w-full overflow-x-auto">
        <table className="w-full min-w-[800px]">
          <thead>
            <tr className="border-y border-gray-200 dark:border-gray-800">
              <th className="px-5 py-3 text-left text-sm font-medium text-brand-500">
                Building
              </th>
              <th className="px-5 py-3 text-left text-sm font-medium text-brand-500">
                Reason
              </th>
              <th className="px-5 py-3 text-left text-sm font-medium text-brand-500">
                Type
              </th>
              <th className="px-5 py-3 text-left text-sm font-medium text-brand-500">
                Tenant Name
              </th>
              <th className="px-5 py-3 text-left text-sm font-medium text-brand-500">
                Tenant Contact Name
              </th>
              <th className="px-5 py-3 text-left text-sm font-medium text-brand-500">
                Status
              </th>
              <th className="px-5 py-3 text-left text-sm font-medium text-brand-500">
                Created At
              </th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={7} className="px-5 py-8 text-center text-gray-500">
                  No activity found
                </td>
              </tr>
            ) : (
              data.map((activity) => (
                <tr
                  key={activity.id}
                  className="border-b border-gray-200 last:border-0 dark:border-gray-800"
                >
                  <td className="px-5 py-4 text-sm text-gray-700 dark:text-gray-300">
                    {activity.building}
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-700 dark:text-gray-300">
                    {activity.reason}
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-700 dark:text-gray-300">
                    {activity.type}
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-700 dark:text-gray-300">
                    {activity.tenant_name}
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-700 dark:text-gray-300">
                    {activity.tenant_contact_name}
                  </td>
                  <td className="px-5 py-4 text-sm">
                    {getStatusBadge(activity.status)}
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-700 dark:text-gray-300">
                    {formatDate(activity.created_at)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
